// material
import { alpha, experimentalStyled as styled } from "@mui/material/styles";
import { Box, AppBar, Toolbar } from "@mui/material";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import useLocales from "hooks/useLocales";
//
// import AccountPopover from "./AccountPopover";
import ComingSoon from "components/ComingSoon";
import LanguagePopover from "./LanguagePopover";
import { useState } from "react";
import CustomizedSwitches from "components/materials/CustomizedSwitches";

// ----------------------------------------------------------------------

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardNavbar() {
  const [show, setShow] = useState(true);
  const { translate } = useLocales();

  setTimeout(() => {
    setShow(false);
  }, 5000);
  return (
    <RootStyle>
      <ToolbarStyle>
        <ComingSoon />
        {show && (
          <Stack sx={{ width: "100%" }} spacing={2}>
            <Alert severity="info">
              {translate(
                "Connect your Piano and refresh the page - does not work yet on IOS"
              )}
            </Alert>
          </Stack>
        )}
        <Box sx={{ flexGrow: 1 }} />

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            "& > *:not(:first-of-type)": {
              ml: { xs: 0.5, sm: 2, lg: 3 },
            },
          }}
        >
          <CustomizedSwitches />
          <LanguagePopover />
        </Box>
      </ToolbarStyle>
    </RootStyle>
  );
}
